import $ = require('jquery');
import Modul, {OpenConfig} from './Modul';
/**
 * ModulFlashElement
 *
 */
export default class ModulFlashElement extends Modul {
    initParameters = {};
    private flashWidth: number = null;
    private flashHeight: number = null;
    private flashRatio: number;

    private $uploadField: JQuery;
    private $form: JQuery;

    constructor(moduleId: number) {
        super(moduleId);

        let self = this;

        this.flashWidth = parseInt(this.getEditorContentPlaceholder().data('width'), 10) || 200;
        this.flashHeight = parseInt(this.getEditorContentPlaceholder().data('height'), 10) || 200;
        this.flashRatio = parseFloat(this.getEditorContentPlaceholder().data('ratio')) ||
            this.flashHeight / this.flashWidth;

        this.$uploadField = $('#flash_upload_wrapper_' + moduleId);

        /* get the form and add DIY form to it */
        this.$form = this.$uploadField.closest('form');
        this.$form.diy_form();

        $("#wrapper_align_" + this.moduleId).diy_combobox({
            editable : false
        });

        this.$uploadField.diy_uploadField({
            change : function() {
                self.$form.diy_form("clearErrors");
                $(this).closest('form').submit();
            }
        });

        this.updateContentSize();
    }

    getEditorContentPlaceholder() {
        return this.getContentContainer().find('.module_flash_admin_content');
    }

    updateContentSize() {
        let contentContainer = this.getContentContainer();
        let contentPlaceholder = this.getEditorContentPlaceholder();

        //when width is too big - take the content width and resize width to keep ratio
        if (this.flashWidth > contentContainer.width()) {
            this.flashWidth = contentContainer.width();
            this.flashHeight = this.flashWidth * this.flashRatio;
        }

        contentPlaceholder.css({
            width: this.flashWidth,
            height: this.flashHeight
        });

        //hide text when it's too big
        if (contentPlaceholder.find('.flash_content_messages').height() >
            contentPlaceholder.height() * 0.8) {
            //hide the text/leave just the filename
            contentPlaceholder.find('.flash_content_info').hide();
            //still too big?
            if (contentPlaceholder.find('.flash_content_messages').height() >
                contentPlaceholder.height() * 0.8) {
                //hide all the text
                contentPlaceholder.find('.flash_content_messages').hide();
            }
        }
    }

    uploadError(errMsg: string) {
        this.$form.diy_form("addError", errMsg, this.$uploadField);
    }

    open(openConfig?: OpenConfig) {
        let self = this;
        super.open(openConfig);
        //show the flash when editor opened
        this.initFlash();
        this.getContentContainer().find('.module_flash_empty_placeholder').click(function() {
            self.$uploadField.find('input[type=file]').trigger('click');
        });
    }

    initFlash() {
        this.getEditorContentPlaceholder().hide();

        //select by class and not id because
        let flashContainer = this.getContentContainer().find('.mediumScreenDisabled');
        let initParameters = flashContainer.data('initParameters');
        flashContainer.show();
        flashContainer.flash.apply(flashContainer, initParameters);
    }

    update(content: string) {
        //empty content - we add placeholder
        if (content.length === 0) {
            super.update('<div class="module_flash_empty_placeholder"></div>');
            return;
        }

        super.update(content);
        this.updateContentSize();
        this.initFlash();
    }

    setOpenStyle(hasConfigView: boolean) {
        super.setOpenStyle(hasConfigView);

        //propagate resize event to form as repositioned event
        this.modul.bind('resize.moduleContent', () => {
            this.$form.trigger('containerRepositioned');
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulFlashElement.ts
 **/